<template>
    <header class="story__head" v-bind="{
        ...markup.parent,
        itemref: hasMarkup && 'cta-linkedin' || undefined,
    }">
        <h1 class="title title--dash" v-bind="markup.name">
            <span 
                data-v-line 
                v-html="formatLine(line, i)"
                v-for="(line, i) in getLines(title)" 
                :key="`head-${i}`" 
            />
        </h1>
        <template v-if="subtitle">
            <h2 
                class="subtitle--header" 
                :class="{
                    'fn': i < 1 
                }"
                v-html="formatRole(formatLine(line, i))"
                v-for="(line, i) in getLines(subtitle)"
                v-bind="markup.job"
                :key="`sub-${i}`" 
            />
        </template>
        <div v-if="hasMarkup" itemprop="worksFor" itemscope itemtype="https://schema.org/Organization">
            <meta itemprop="name" content="Doane Grant Thornton" />
        </div>
    </header>
</template>

<script>
export default {
    props: {
        title: [Array, String],
        subtitle: [Array, String],
        hasMarkup: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        markup() {
            if (!this.hasMarkup) {
                return {}
            }
            return {
                parent: {
                    'itemscope': "",
                    'itemtype': "https://schema.org/Person"
                },
                name: {
                    'itemprop': "name"
                },
                job: {
                    'itemprop': "jobTitle"
                },
            }
        }
    },
    methods: {
        getLines( text ) {
            return Array.isArray(text) ? text : [text]
        },
        formatLine( text, i ) {
            if ( !i ) {
                return `${text}&nbsp;`
            }
            return text
        },
        formatRole( role ) {
            return role
            // return String(role).split(', ').join(`&nbsp;|&nbsp;`)
        },
    },
}
</script>